import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportFrontendError } from "@/lib/error-reporting";

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportFrontendError("react", error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="min-h-screen bg-background px-6 py-24 text-foreground">
          <section className="mx-auto max-w-prose border border-border bg-card p-8 text-card-foreground shadow-sm">
            <p className="text-sm uppercase tracking-[0.18em] text-muted-foreground">Błąd aplikacji</p>
            <h1 className="mt-4 text-4xl">Nie udało się wyświetlić tej sekcji.</h1>
            <p className="mt-4 text-muted-foreground">
              Szczegóły techniczne zostały zapisane w logach przeglądarki ze stack trace’em.
            </p>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}